import {
	CLEAR_DOC_TYPE_MANAGEMENT_STATE,
	GET_ALL_DOC_TYPES,
	GET_ALL_DOC_TYPES_SUCCESS,
	GET_ALL_DOC_TYPES_ERROR,
	GET_DOC_TYPE_BY_ID,
	GET_DOC_TYPE_BY_ID_SUCCESS,
	GET_DOC_TYPE_BY_ID_ERROR,
	CREATE_DOC_TYPE,
	CREATE_DOC_TYPE_SUCCESS,
	CREATE_DOC_TYPE_ERROR,
	UPDATE_DOC_TYPE,
	UPDATE_DOC_TYPE_SUCCESS,
	UPDATE_DOC_TYPE_ERROR,
	DELETE_DOC_TYPE,
	DELETE_DOC_TYPE_SUCCESS,
	DELETE_DOC_TYPE_ERROR,
} from './actions';
import api from '@/utils/api';

const { http } = api.getInstance();
const DOC_TYPE_URL = '/docType';

const defaultState = () => ({
	docTypesList: [],
	isLoadingDocTypes: '',
});

const state = defaultState();

const getters = {
	docTypesList: (state) => state.docTypesList,
	isLoadingDocTypes: (state) => state.isLoadingDocTypes === 'loading',
};

const mutations = {
	[CLEAR_DOC_TYPE_MANAGEMENT_STATE]: (state) => {
		Object.assign(state, defaultState());
	},
	[GET_ALL_DOC_TYPES]: (state) => {
		state.isLoadingDocTypes = 'loading';
	},
	[GET_ALL_DOC_TYPES_SUCCESS]: (state, data) => {
		state.docTypesList = data;
		state.isLoadingDocTypes = 'success';
	},
	[GET_ALL_DOC_TYPES_ERROR]: (state) => {
		state.isLoadingDocTypes = 'error';
	},
	[GET_DOC_TYPE_BY_ID]: (state) => {
		state.isLoadingDocTypes = 'loading';
	},
	[GET_DOC_TYPE_BY_ID_SUCCESS]: (state, data) => {
		state.isLoadingDocTypes = 'success';
	},
	[GET_DOC_TYPE_BY_ID_ERROR]: (state) => {
		state.isLoadingDocTypes = 'error';
	},
	[CREATE_DOC_TYPE]: (state) => {
		state.isLoadingDocTypes = 'loading';
	},
	[CREATE_DOC_TYPE_SUCCESS]: (state) => {
		state.isLoadingDocTypes = 'success';
	},
	[CREATE_DOC_TYPE_ERROR]: (state) => {
		state.isLoadingDocTypes = 'error';
	},
	[UPDATE_DOC_TYPE]: (state) => {
		state.isLoadingDocTypes = 'loading';
	},
	[UPDATE_DOC_TYPE_SUCCESS]: (state, data) => {
		state.isLoadingDocTypes = 'success';
	},
	[UPDATE_DOC_TYPE_ERROR]: (state) => {
		state.isLoadingDocTypes = 'error';
	},
	[DELETE_DOC_TYPE]: (state) => {
		state.isLoadingDocTypes = 'loading';
	},
	[DELETE_DOC_TYPE_SUCCESS]: (state, data) => {
		state.isLoadingDocTypes = 'success';
	},
	[DELETE_DOC_TYPE_ERROR]: (state) => {
		state.isLoadingDocTypes = 'error';
	},
};

const actions = {
	[GET_ALL_DOC_TYPES]: async ({ commit }, { vm, params }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_DOC_TYPES);
			localStorage.setItem(`lastReqAdm`, 'docTypeManagement/GET_ALL_DOC_TYPES');

			http({
				method: 'GET',
				url: `${DOC_TYPE_URL}${params}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_DOC_TYPES_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_DOC_TYPES_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_DOC_TYPE_BY_ID]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(GET_DOC_TYPE_BY_ID);

			http({
				method: 'GET',
				url: `${DOC_TYPE_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_DOC_TYPE_BY_ID_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_DOC_TYPE_BY_ID_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[CREATE_DOC_TYPE]: async ({ commit }, { vm, body }) => {
		return new Promise((resolve, reject) => {
			commit(CREATE_DOC_TYPE);

			http({
				method: 'POST',
				url: `${DOC_TYPE_URL}`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Tipo de Documento criado com sucesso.');
					commit(CREATE_DOC_TYPE_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(CREATE_DOC_TYPE_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[UPDATE_DOC_TYPE]: async ({ commit }, { vm, id, body }) => {
		return new Promise((resolve, reject) => {
			commit(UPDATE_DOC_TYPE);

			http({
				method: 'PATCH',
				url: `${DOC_TYPE_URL}/${id}`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Tipo de Documento editado com sucesso.');
					commit(UPDATE_DOC_TYPE_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(UPDATE_DOC_TYPE_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[DELETE_DOC_TYPE]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(DELETE_DOC_TYPE);

			http({
				method: 'DELETE',
				url: `${DOC_TYPE_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Tipo de Documento excluído com sucesso.');
					commit(DELETE_DOC_TYPE_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(DELETE_DOC_TYPE_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
